import type { IEnvironment } from '@novu/shared';
import React from 'react';

export type EnvironmentContextValue = {
  currentEnvironment?: IEnvironment;
  environments?: IEnvironment[];
  areEnvironmentsInitialLoading: boolean;
  /**
   * Set when loading environments failed (the query is `retry: false`). Consumers must not
   * redirect on a failure — routing on it produces an infinite `/` <-> `/auth/organization-list`
   * bounce, because the org picker legitimately sends the user back to `/`.
   */
  environmentsError?: unknown;
  readOnly: boolean;
  switchEnvironment: (newEnvironmentSlug?: string) => void;
  setBridgeUrl: (url: string) => void;
  oppositeEnvironment: IEnvironment | null;
};

export const EnvironmentContext = React.createContext<EnvironmentContextValue>({} as EnvironmentContextValue);
EnvironmentContext.displayName = 'EnvironmentContext';
